import { NgClass } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ClassDirective } from "@ngbracket/ngx-layout/extended";
import { Utilities } from "@tylertech/shared-module";
import { PropertyMetadata } from "@tylertech/tyler-api-types";
import { FocusOnLoadDirective } from "../../../../directives/focusOnLoad.directive";

@Component({
    selector: "metadata-label",
    templateUrl: "./metadata-label.tmpl.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FocusOnLoadDirective,
        NgClass,
        ClassDirective,
    ],
})
export class MetadataLabelComponent
{
    @Input() label: string;
    @Input() propertyMetadata: PropertyMetadata;
    @Input() compact?: boolean;
    @Input() dense?: boolean;

    get includeDivider(): boolean
    {
        return this.propertyMetadata.Required;
    }

    get showHeader(): boolean
    {
        return !Utilities.IsNullOrUndefined(this.label?.length) && this.label?.length > 0;
    }

    get fontWeight(): string
    {
        return this.propertyMetadata.Bold === true ? '500' : 'inherit';
    }
}
